export const addObjectToFormData = (data, formData, priorKey = null) => {
  Object.keys(data).forEach((key) => {
    let entryKey = priorKey ? `${ priorKey }[${ key }]` : key;
    const entryValue = data[key];

    // Undefined or null
    if (typeof entryValue === 'undefined' || entryValue === null) {
      return;
    }

    // Array
    if (Array.isArray(entryValue)) {
      entryKey += '[]';
      entryValue.forEach((arrayEntry) => {
        if (typeof arrayEntry === 'object') {
          addObjectToFormData(arrayEntry, formData, entryKey);
        } else {
          formData.append(entryKey, arrayEntry);
        }
      });

      if (!entryValue.length) {
        formData.append(entryKey, entryValue);
      }

      return;
    }

    // File
    if (typeof entryValue.size === 'number' && typeof entryValue.type === 'string') {
      formData.append(entryKey, entryValue);
      return;
    }

    // Parent
    if (typeof entryValue === 'object') {
      addObjectToFormData(entryValue, formData, entryKey);
      return;
    }

    // Primitive data
    formData.append(entryKey, entryValue);
  });
};

export const adjustUrl = (fieldValue) => {
  if (!fieldValue) {
    return fieldValue;
  }

  fieldValue = fieldValue.replace(/ /gi, '');

  if (!fieldValue.startsWith('http')) {
    return fieldValue = `https://${ fieldValue }`;
  }

  return fieldValue;
};

export const stripHandleFromField = (fieldValue) => {
  if (!fieldValue || !fieldValue.length) {
    return fieldValue;
  }

  if (fieldValue.startsWith('@')) {
    return fieldValue.substring(1);
  }

  return fieldValue;
};

export const addHandleToField = (fieldValue) => {
  if (!fieldValue || !fieldValue.length) {
    return fieldValue;
  }

  if (!fieldValue.startsWith('@')) {
    return `@${ fieldValue }`;
  }

  return fieldValue;
};
